"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var invalid_user_input_error_1 = require("./invalid-user-input-error");
exports.InvalidUserInputError = invalid_user_input_error_1.InvalidUserInputError;
// Other common parser error types:
// OutOfSyncError - not applicable yet, since for dep/vendor, the manifests do not contain the names of actual
// modules/packages used, so they cannot be out of sync with the lockfiles.
//# sourceMappingURL=index.js.map